(function() {

    // Localize jQuery variable
    var jQuery;
    var $e; // Main widget container. This is a jQuery object
    var LOG_PREFIX = 'IguanaFix widget: ';

    /******** Load jQuery if not present *********/
    if (window.jQuery === undefined || window.jQuery.fn.jquery !== '1.9.1') {
        var script_tag = document.createElement('script');
        script_tag.setAttribute("type","text/javascript");
        script_tag.setAttribute("src",
            "https://ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js");
        if (script_tag.readyState) {
          script_tag.onreadystatechange = function () { // For old versions of IE
              if (this.readyState == 'complete' || this.readyState == 'loaded') {
                  scriptLoadHandler();
              }
          };
        } else {
          script_tag.onload = scriptLoadHandler;
        }
        // Try to find the head, otherwise default to the documentElement
        (document.getElementsByTagName("head")[0] || document.documentElement).appendChild(script_tag);
    } else {
        // The jQuery version on the window is the one we want to use
        jQuery = window.jQuery;
        main();
    }

    /******** Called once jQuery has loaded ******/
    function scriptLoadHandler() {
        // Restore $ and window.jQuery to their previous values and store the
        // new jQuery in our local jQuery variable
        jQuery = window.jQuery.noConflict(true);
        // Call our main function
        main();
    }

    /******** Our main function ********/
    function main() {
        jQuery(document).ready(function($) {
            /******* Markup Init *******/
            $e = jQuery('#iguanafix-widget-box');
            if(! $e){
                throw LOG_PREFIX + "Missing initial markup.";
            }

            var proId = $e.data('pid');
            if(! proId) {
                throw LOG_PREFIX + "Missing pro id parameter. Check required parameter in initial markup.";
            }

            var hostUrl = getHostUrl();
            if(!hostUrl) {
                throw LOG_PREFIX + "Cannot obtain remote host url. Will not procede.";
            }

            if(!integrityCheck(hostUrl)) {
                throw LOG_PREFIX + "Provided code has been tampered. Will not procede.";   
            }

            var locale = $e.data('lang') || 'es';

            /******* Load CSS *******/
            var css_fonts_link = $("<link>", {
                rel: "stylesheet",
                type: "text/css",
                href: "https://fonts.googleapis.com/css?family=Tauri|Crete+Round:400,400italic"
            });
            css_fonts_link.appendTo('head');
            var css_link = $("<link>", {
                rel: "stylesheet",
                type: "text/css",
                href: hostUrl + "static/css/marb-widget.css"
            });
            css_link.appendTo('head');

            /******* Load HTML *******/
            var jsonp_url = hostUrl + "company/" + proId + "/info?lang=" + locale + "&callback=?";
            $.getJSON(jsonp_url, function(data) {
                renderWidget(data);
            });
        });
    }

    function getHostUrl() {
        var domain, abort = false;
        jQuery('script').each(function() {
            var scriptUrl = jQuery(this).attr('src');
            console.log(scriptUrl);
            if(scriptUrl && scriptUrl.indexOf('marb-widget-min.js') != -1 || scriptUrl.indexOf('marb-widget.js') != -1) {
                var match = /(https?:\/\/.*\/)static/.exec(scriptUrl);
                if( match == null ){
                	match = location.hostname;
                }
                if(match == null) {
                    abort = true;
                    return false;
                }
                domain = match[1];

                return false; //works as a 'break' statement inside a loop
            }
        });
        console.log(domain);
        if(abort) {
            return null;
        }

        return domain;
    }

    function integrityCheck(hostUrl) {
        $noscript = jQuery('#ifix-noscript');
        if($noscript.length == 0) {
            return false;
        }

        var regex = new RegExp('<a href="' + hostUrl,'g');
        var regexMatch = $noscript.text().match(regex);

        return regexMatch != null && regexMatch.length == 2;

    }

    function renderWidget(data) {
        var bannerHtml = 
            '<div class="ifix-widget-banner"> \
                <div class="ifix-header"> \
                    <a href="'+ data.siteUrl +'" target="_blank">'+ data.lang.mainTitle +'</a> \
                </div> \
                <div class="ifix-body"> \
                    <div class="ifix-l"> \
                        <img src="' + data.companyPic + '" /> \
                        <a class="btn btn-orange btn-small" href="'+ data.siteUrl + data.companyUrl +'" target="_blank">'+ data.lang.buttonSeeProfile +' \
                            <img src="'+ data.siteUrl +'static/images/widget_icon_profile.png" /> \
                        </a> \
                    </div> \
                    <div class="ifix-c"> \
                        <div class="ifix-sec-title">'+ data.lang.reviewsTitle +'</div> \
                        <ul class="ifix-rating"> \
                            <li>'+ data.lang.reviewsJobsDone +' <span class="stars" rel="' + data.ratingJobsDone + '" /></li> \
                            <li>'+ data.lang.reviewsOnTime +' <span class="stars" rel="' + data.ratingOnTime + '" /></li> \
                            <li>'+ data.lang.reviewsOnBudget +' <span class="stars" rel="' + data.ratingOnBudget + '" /></li> \
                            <li>'+ data.lang.reviewsKindness +' <span class="stars" rel="' + data.ratingKindness + '" /></li> \
                        </ul> \
                    </div> \
                    <div class="ifix-r"> \
                        <div class="ifix-sec-title">'+ data.lang.historicTitle +'</div> \
                        <ul class="ifix-verif"> \
                            <li><img src="'+ data.siteUrl +'static/images/verified.png" />' + data.jobsDone + ' ' + data.lang.historicJobsDone +'</li> \
                            <li><img src="'+ data.siteUrl +'static/images/verified.png" />'+ data.lang.historicVerified +'</li> \
                        </ul> \
                        <a class="btn btn-green" href="'+ data.siteUrl + data.companyUrl +'#menu-comments" target="_blank">'+ data.lang.buttonSeeComments +' \
                            <img src="'+ data.siteUrl +'static/images/widget_icon_comments.png" /> \
                        </a> \
                    </div> \
                </div> \
            </div>';
        var boxHtml = 
            '<div class="ifix-widget-box"> \
                <div class="ifix-header"> \
                    <div class="ifix-title">'+ data.lang.mainTitle +'</div> \
                    <img class="ifix-company-pic" src="' + data.companyPic + '" /> \
                    <a class="ifix-logo-wrapper" href="'+ data.siteUrl +'" target="_blank"> \
                        <img src="'+ data.siteUrl +'static/images/logo.png" /> \
                        <span>www.iguanafix.com</span> \
                    </a> \
                </div><div class="ifix-body-gradient"> \
                <div class="ifix-sec-rating"> \
                    <div class="ifix-sec-title">'+ data.lang.reviewsTitle +'</div> \
                    <ul class="ifix-rating"> \
                        <li>'+ data.lang.reviewsJobsDone +' <span class="stars" rel="' + data.ratingJobsDone + '" /></li> \
                        <li>'+ data.lang.reviewsOnTime +' <span class="stars" rel="' + data.ratingOnTime + '" /></li> \
                        <li>'+ data.lang.reviewsOnBudget +' <span class="stars" rel="' + data.ratingOnBudget + '" /></li> \
                        <li>'+ data.lang.reviewsKindness +' <span class="stars" rel="' + data.ratingKindness + '" /></li> \
                    </ul> \
                </div> \
                <div class="ifix-sec-verif"> \
                    <div class="ifix-sec-title">'+ data.lang.historicTitle +'</div> \
                    <ul class="ifix-verif"> \
                        <li><img src="'+ data.siteUrl +'static/images/verified.png" />' + data.jobsDone + ' ' + data.lang.historicJobsDone +'</li> \
                        <li><img src="'+ data.siteUrl +'static/images/verified.png" />'+ data.lang.historicVerified +'</li> \
                    </ul> \
                </div> \
                <div class="ifix-footer"> \
                    <a class="btn btn-green btn-small ifix-comments" href="'+ data.siteUrl + data.companyUrl +'#menu-comments" target="_blank">'+ data.lang.buttonSeeComments +' \
                        <img src="'+ data.siteUrl +'static/images/widget_icon_comments.png" /> \
                    </a> \
                    <a class="btn btn-orange btn-small ifix-profile" href="'+ data.siteUrl + data.companyUrl +'" target="_blank">'+ data.lang.buttonSeeProfile +' \
                        <img src="'+ data.siteUrl +'static/images/widget_icon_profile.png" /> \
                    </a> \
                </div></div> \
            </div>';

        switch($e.data('style')) {
            case 'banner':
                $e.html(bannerHtml);
                break;
            case 'box':
                $e.html(boxHtml);
                break;
            default:
                $e.html(bannerHtml);
        }

        $e.find('.stars').each(function(i, e) {
            var q = jQuery(this).attr('rel');
            var s = '';
            for(var i=0; i < 5; i++) {
                if(q-- > 0) {
                    s += '<img src="' + data.siteUrl + 'static/images/starOn.png"/>';
                } else {
                    s += '<img src="' + data.siteUrl + 'static/images/starOff.png"/>';
                }
            }
            jQuery(this).html(s);
        });
    }

})(); // We call our anonymous function immediately